import styled from 'styled-components';
import { fontSize } from '../utils/style/font';
import space from '../utils/style/space';
import SmallText from '../atoms/SmallText';
import Checkbox from '../atoms/Checkbox';
import i18n from '../R/string/i18n';

const NotificationTextWrapper = styled.div`
  font-size: ${fontSize.m}px;
  margin: ${space.m}px 0;
`;
const SmallTextWrap = styled.span`
  width: calc(100% - 50px);
`;

const CheckTextWrap = styled.div`
  display: flex;
  align-items: center;
`;

type Props = {
  needReceiveEmail?: boolean;
  toggleReceiveEmail?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  marginLeft?: number;
};

const ReceiveWamazingMail = ({
  needReceiveEmail,
  toggleReceiveEmail,
  marginLeft
}: Props) => (
  <NotificationTextWrapper>
    <CheckTextWrap>
      <Checkbox
        checked={needReceiveEmail}
        type="checkbox"
        onChange={toggleReceiveEmail}
      />
      <SmallTextWrap>
        <SmallText>{i18n.commonReceiveEmailUpdatesFromWAmazing()}</SmallText>
      </SmallTextWrap>
    </CheckTextWrap>
    <div style={{ marginLeft: marginLeft ? `${marginLeft}px` : '27px' }}>
      <SmallText>{i18n.notificationsMailExplanatoryText()}</SmallText>
    </div>
  </NotificationTextWrapper>
);

export default ReceiveWamazingMail;
